import { TagsResponse, Tag } from './../../models/ghost/Tag';
import { PostResponse, Post } from './../../models/ghost/Post';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

/*
  Generated class for the GhostProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GhostProvider {

  clientSecret: string = "5b19307eb4a1";
  baseURL: string = 'https://blocktistics.com/ghost/api/v0.1';

  singleTag: Tag = null;

  imgRegex: RegExp = null;
  constructor(public http: HttpClient) {
    this.imgRegex = new RegExp('/content/images', 'g');
    // this.getTags().subscribe((tags: Tag[]) => {
    //   console.log(tags);
    // })
  }

  getTags(): Observable<Tag[]>{
    let url = `${this.baseURL}/tags`
    let params = {
      'client_id': 'ghost-frontend',
      'client_secret': this.clientSecret,
      'limit': 'all'
    }
    return this.http.get(url, { params: params })
      .map((response: TagsResponse) => {
        return response.tags
      })
  }

  getGuidesTags(): Observable<Tag[]>{
    return this.getTags().map(tags => {
      return tags.filter(tag => {
        const name = tag.name.toLocaleLowerCase();
        return !(name == 'help' || name == 'glossary' || name == 'guide');
      })
    })
  }

  getPostTitles(page: number): Observable<PostResponse>{
    let url = `${this.baseURL}/posts`
    let params = {
      'client_id': 'ghost-frontend',
      'client_secret': this.clientSecret,
      'fields': 'id,title,published_at,feature_image',
      'page': page.toString()
    }
    return this.http.get(url, { params: params })
      .map((response: PostResponse) => {
        return response;
      })
  }

  getGuidesByTag(page: number, tag: Tag): Observable<PostResponse>{
    let url = `${this.baseURL}/posts`
    let params = {
      'client_id': 'ghost-frontend',
      'client_secret': this.clientSecret,
      'page': page.toString()
    }

    if(tag){
      params['filter'] = `tags:${tag.name}`;
    }else{
      params['filter'] = `tags:Guide`;
    }

    return this.http.get(url, { params: params })
      .map((response: PostResponse) => {
        return response;
      })
  }

  getGlossary(): Observable<PostResponse>{
    let url = `${this.baseURL}/posts`
    let params = {
      'client_id': 'ghost-frontend',
      'client_secret': this.clientSecret,
      'filter': 'tags:[glossary]',
      'limit': 'all'
    }

    return this.http.get(url, { params: params })
      .map((response: PostResponse) => {
        return response;
      })
  }


  getPostBySlug(slug: string): Observable<Post>{
    let url = `${this.baseURL}/posts/slug/${slug}`

    let params = {
      'client_id': 'ghost-frontend',
      'client_secret': this.clientSecret
    }

    return this.http.get(url, { params: params })
      .map((response: PostResponse) => {
        return response.posts[0];
      }).map(post => {
        // loader.dismiss();
        post.html = post.html.replace(this.imgRegex, 'https://blocktistics.com/content/images');
        return post;
      });
  }

  getPostById(id: string): Observable<Post>{
    let url = `${this.baseURL}/posts/${id}`

    let params = {
      'client_id': 'ghost-frontend',
      'client_secret': this.clientSecret
    }

    return this.http.get(url, { params: params })
      .map((response: PostResponse) => {
        return response.posts[0];
      }).map(post => {
        // loader.dismiss();
        post.html = post.html.replace(this.imgRegex, 'https://blocktistics.com/content/images');
        return post;
      });
  }


}



// WEBPACK FOOTER //
// ./src/providers/ghost/ghost.ts